import { useMutation, useQueryClient } from '@tanstack/react-query';
import { requestRevokeContactConsent } from '../contactConsent/contactConsent';
import { RevokeContactConsentRequest } from '../contactConsent/types/ContactConsent';

export function useRevokeConsent(contactId: number) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: RevokeContactConsentRequest) =>
            (await requestRevokeContactConsent(data)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`contact-${contactId}`, 'data'] });
        },
    });
}
